import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { msalInstance } from '../../App';

export const UserError = () => {
  const { t } = useTranslation();
  const title = t('user_error.title');
  const logout = t('user_error.logout');

  const handleLogout = async () => {
    await msalInstance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap={5}
      paddingTop={10}
    >
      <h3>{title}</h3>
      <Button variant="contained" color="primary" onClick={handleLogout}>
        {logout}
      </Button>
    </Box>
  );
};
